import placeholder from '@/packages/components/base/image/src/assets/img/placeholder.png'

/**
 * 组件信息
 */
export const info = {
  name: 'xy-double-faced-image', // 组件名
  type: 'component-business', // 组件类型
  label: '双面图片', // 组件label
  icon: 'icon-xy-image', // 组件图标
  defaultWidth: 750, // 组件默认宽度
  defaultHeight: 400 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  // 正面图片链接
  frondSrc: { type: String, default: placeholder },
  // 反面图片链接
  backSrc: { type: String, default: placeholder },
  // 图片填充方式
  fit: { type: String, default: 'fill' },
  // 对应索引
  index: { type: Number, default: 0 },
  // 所属翻牌组件
  raffleId: { type: String, default: '' }
}

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-double-faced-image'
  }
]
